import { Component, HostBinding, HostListener, Input, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ChartElementOrientation, ChartElementSize } from '../interfaces';

@Component({
  standalone: false,
  selector: 'campus-chart-element',
  templateUrl: './chart-element.component.html',
  styleUrls: ['./chart-element.component.scss'],
})
export class ChartElementComponent {
  @Input() value: number;
  @Input() colorClass?: string;
  @Input() size?: ChartElementSize = 'small';
  @Input() showTrack? = false;
  @Input() orientation?: ChartElementOrientation = 'horizontal';
  @Input() tooltip?: string;

  @HostBinding('class')
  get hostClasses(): string {
    return [
      'ui-chart-element',
      `ui-chart-element--${this.orientation}`,
      `ui-chart-element--${this.size}`,
      this.showTrack && 'ui-chart-element--track',
    ].join(' ');
  }

  @HostBinding('attr.data-cy')
  cyAttribute = 'chart-value';

  @ViewChild(MatTooltip, { static: true }) tooltipEl: MatTooltip;

  @HostListener('mouseenter')
  onMouseEnter() {
    this.tooltipEl.show();
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.tooltipEl.hide();
  }
}
